module.exports = __webpack_public_path__ + "static/media/all-biddings.ed4c8b9c.svg";